import React from 'react';
import { Center, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from '../../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../../common/hooks/use-param-back-url';
import { createLocationPermissionIcon } from '../../../../styles/create-location-permission-icon';
import { hasLocationPermission, openAppSettings, useAppStateWatcher } from './location-permission-helpers';

export function LocationRequiredError() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const backURL = useParamBackUrl('../location_info');
  const LocationPermissionIcon = createLocationPermissionIcon('#FF5B44');

  // watching permissions from app settings to continue
  useAppStateWatcher(async () => {
    const granted = await hasLocationPermission();

    if (granted) {
      navigate('../first_time_hardware_configuration', { replace: true });
    }
  });

  return (
    <SlidingAnimationPageBase includeTopNav title={t('Common.device setup')} backURL={backURL}>
      <Center flexDirection="column" px={3} textAlign="center">
        <LocationPermissionIcon data-testid="location-permission-image" h="300px" w="300px" />

        <Heading mt={2}>{t('Location.location needed')}</Heading>
        <Text mt={1}>{t('Location.please enable location')}</Text>
        <Text mt={4}>{t('Location.please turn on location')}</Text>
        <ArcButton onClick={async () => await openAppSettings()} mt={8} w={'80%'} arcColor="#3DCD57">
          {t('Common.go to settings')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
}
